<template lang="pug">
.date-range-select
  .input-container.arrow
    select.select(v-model="selectedRange" @change="onRangeChange")
      option(v-for="option in options" :key="option.value" :value="option.value") {{ option.label }}
    label.label.show
      span(v-if="display") {{ display }}
      span(v-else) Fecha

  .date-range-custom(v-if="selectedRange === 'customMonth'")
    .input-container.arrow
      select.select(v-model="customMonth" @change="onCustomMonthChange")
        option(v-for="m in months" :key="m.value" :value="m.value") {{ m.label }}
      label.label.show Mes
    .input-container.arrow
      select.select(v-model="customYear" @change="onCustomMonthChange")
        option(v-for="y in years" :key="y" :value="y") {{ y }}
      label.label.show Año

  .date-range-custom(v-if="selectedRange === 'custom'")
    .input-container
      input.input(v-model="customInit" type="date" required)
      label.label(:class="{ show: customInit }") {{ showFinal ? 'Fecha Inicial' : 'Fecha' }}
    .order-direction.pointer(v-if="customInit && !showFinal" @click="showFinal = true" role="button" tabindex="0" @keyup.enter="showFinal = true")
      span.material-symbols-outlined add
    .input-container(v-if="showFinal")
      input.input(v-model="customFinal" type="date")
      label.label(:class="{ show: customFinal }") Fecha Final
    .order-direction.pointer(v-if="showFinal" @click="removeFinal" role="button" tabindex="0" @keyup.enter="removeFinal")
      span.material-symbols-outlined close
</template>

<script>
const MONTH_NAMES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

function toDisplay (dateStr) {
  if (!dateStr) return ''
  const [y, m, d] = dateStr.split('-')
  return `${parseInt(d)} ${MONTH_NAMES[parseInt(m) - 1]} ${y}`
}

export default {
  name: 'DateRangeSelect',

  props: {
    value: {
      type: String,
      default: ''
    },
    initDate: {
      type: String,
      default: ''
    },
    finalDate: {
      type: String,
      default: ''
    },
    defaultRange: {
      type: String,
      default: ''
    },
    extraOptions: {
      type: Array,
      default: () => []
    }
  },

  mounted () {
    console.log(this.value)
  },

  data () {
    const now = new Date()
    return {
      selectedRange: this.value || this.defaultRange || '',
      customInit: this.initDate || '',
      customFinal: this.finalDate || '',
      customMonth: now.getMonth(),
      customYear: now.getFullYear(),
      resolvedInit: this.initDate || '',
      resolvedFinal: this.finalDate || '',
      showFinal: !!(this.finalDate && this.finalDate !== this.initDate)
    }
  },

  computed: {
    display () {
      const init = toDisplay(this.resolvedInit)
      const final = toDisplay(this.resolvedFinal)
      if (!init || !final) return ''
      return init === final ? init : `${init} — ${final}`
    },
    months () {
      return [
        { value: 0, label: 'Enero' },
        { value: 1, label: 'Febrero' },
        { value: 2, label: 'Marzo' },
        { value: 3, label: 'Abril' },
        { value: 4, label: 'Mayo' },
        { value: 5, label: 'Junio' },
        { value: 6, label: 'Julio' },
        { value: 7, label: 'Agosto' },
        { value: 8, label: 'Septiembre' },
        { value: 9, label: 'Octubre' },
        { value: 10, label: 'Noviembre' },
        { value: 11, label: 'Diciembre' }
      ]
    },
    years () {
      const currentYear = new Date().getFullYear()
      const result = []
      for (let y = currentYear; y >= 2019; y--) result.push(y)
      return result
    },
    options () {
      const base = [
        { value: '', label: '' },
        { value: 'today', label: 'Hoy' },
        { value: 'yesterday', label: 'Ayer' },
        { value: 'thisWeek', label: 'Esta semana' },
        { value: 'lastWeek', label: 'Semana pasada' },
        { value: 'thisMonth', label: 'Este mes' },
        { value: 'lastMonth', label: 'Mes pasado' },
        { value: 'last3Months', label: 'Últimos 3 meses' },
        { value: 'last6Months', label: 'Últimos 6 meses' },
        { value: 'thisYear', label: 'Este año' },
        { value: 'lastYear', label: 'Año pasado' },
        { value: 'last2Years', label: 'Últimos 2 años' },
        { value: 'last10Years', label: 'Últimos 10 años' },
        { value: 'customMonth', label: 'Personalizar mes y año' },
        { value: 'custom', label: 'Personalizado' }
      ]
      return [...base, ...this.extraOptions]
    }
  },

  watch: {
    value (val) {
      if (val !== this.selectedRange) {
        this.selectedRange = val
        if (val && val !== 'custom' && val !== 'customMonth') this.emitRange()
      }
    },
    initDate (val) {
      if (val !== this.customInit) this.customInit = val
    },
    finalDate (val) {
      if (val !== this.customFinal) this.customFinal = val
    },
    display (val) {
      this.$emit('display-change', val)
    },
    customInit () {
      if (this.selectedRange === 'custom') this.emitRange()
    },
    customFinal () {
      if (this.selectedRange === 'custom') this.emitRange()
    }
  },

  created () {
    if (this.selectedRange) this.emitRange()
  },

  methods: {
    removeFinal () {
      this.showFinal = false
      this.customFinal = ''
      this.emitRange()
    },

    onRangeChange () {
      if (this.selectedRange !== 'custom') {
        this.customInit = ''
        this.customFinal = ''
        this.showFinal = false
      }
      if (this.selectedRange === 'customMonth') {
        const now = new Date()
        this.customMonth = now.getMonth()
        this.customYear = now.getFullYear()
      }
      this.emitRange()
    },

    onCustomMonthChange () {
      this.emitRange()
    },

    emitRange () {
      if (!this.selectedRange) {
        this.resolvedInit = ''
        this.resolvedFinal = ''
        this.$emit('change', { init: '', final: '', selected: '' })
        return
      }

      let range
      if (this.selectedRange === 'custom') {
        range = { init: this.customInit, final: this.customFinal || this.customInit }
      } else if (this.selectedRange === 'customMonth') {
        const firstDay = new Date(this.customYear, this.customMonth, 1)
        const lastDay = new Date(this.customYear, this.customMonth + 1, 0)
        range = { init: this.formatDate(firstDay), final: this.formatDate(lastDay) }
      } else {
        range = this.computeRange(this.selectedRange)
      }

      const { init, final } = range
      this.resolvedInit = init
      this.resolvedFinal = final

      this.$emit('change', { init, final, selected: this.selectedRange })
    },

    formatDate (date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },

    computeRange (key) {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

      const ranges = {
        today: () => ({
          init: today,
          final: today
        }),

        yesterday: () => {
          const d = new Date(today)
          d.setDate(d.getDate() - 1)
          return { init: d, final: d }
        },

        thisWeek: () => {
          const day = today.getDay()
          const diff = day === 0 ? 6 : day - 1
          const monday = new Date(today)
          monday.setDate(monday.getDate() - diff)
          return { init: monday, final: today }
        },

        lastWeek: () => {
          const day = today.getDay()
          const diff = day === 0 ? 6 : day - 1
          const thisMonday = new Date(today)
          thisMonday.setDate(thisMonday.getDate() - diff)
          const lastMonday = new Date(thisMonday)
          lastMonday.setDate(lastMonday.getDate() - 7)
          const lastSunday = new Date(thisMonday)
          lastSunday.setDate(lastSunday.getDate() - 1)
          return { init: lastMonday, final: lastSunday }
        },

        thisMonth: () => {
          const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
          return { init: firstDay, final: today }
        },

        lastMonth: () => {
          const firstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1)
          const lastDay = new Date(today.getFullYear(), today.getMonth(), 0)
          return { init: firstDay, final: lastDay }
        },

        last3Months: () => {
          const d = new Date(today)
          d.setMonth(d.getMonth() - 3)
          return { init: d, final: today }
        },

        last6Months: () => {
          const d = new Date(today)
          d.setMonth(d.getMonth() - 6)
          return { init: d, final: today }
        },

        thisYear: () => {
          const init = new Date(today.getFullYear(), 0, 1)
          return { init, final: today }
        },

        lastYear: () => {
          const init = new Date(today.getFullYear() - 1, 0, 1)
          const final = new Date(today.getFullYear() - 1, 11, 31)
          return { init, final }
        },

        last2Years: () => {
          const d = new Date(today)
          d.setFullYear(d.getFullYear() - 2)
          return { init: d, final: today }
        },

        last10Years: () => {
          const d = new Date(today)
          d.setFullYear(d.getFullYear() - 10)
          return { init: d, final: today }
        }
      }

      const compute = ranges[key]
      if (!compute) return { init: '', final: '' }

      const result = compute()
      return {
        init: this.formatDate(result.init),
        final: this.formatDate(result.final)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.date-range-select
  width 100%

.date-range-preview
  font-size 1.1em
  color var(--color-font-principal)
  opacity .7
  padding .3em 1.25em 0

.date-range-custom
  display flex
  align-items center
  gap 1em
  margin-top 1rem

.order-direction
  flex-shrink 0
  display flex
  align-items center
  align-self flex-end

  .material-symbols-outlined
    font-size 2rem
    color rgba(0, 0, 0, .8)
    margin-bottom 1.6rem
</style>



// WEBPACK FOOTER //
// src/components/helpers/DateRangeSelect.vue